var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9891 4.22217L20.1407 4.21814L20.2881 4.22204C20.3604 4.22619 20.4329 4.2337 20.5052 4.24465L20.557 4.25693C20.8322 4.30113 21.1057 4.39943 21.3663 4.55382L21.5334 4.66188L37.8689 16.1485L54.1938 4.67267C55.7009 3.61338 57.7426 4.56548 57.9774 6.31279L58 6.64944V40.9052C58 41.5795 57.7184 42.2178 57.2326 42.6714L56.9732 42.8821L39.2533 55.3389C38.3934 55.9433 37.3592 55.8927 36.5863 55.4133L20.1394 43.8429L3.806 55.3279C2.2991 56.3872 0.257324 55.4352 0.0223266 53.6877L0 53.3513V19.0953C0 18.4209 0.281456 17.7828 0.767174 17.3292L1.02672 17.1186L18.7466 4.66188C18.9528 4.51693 19.169 4.40964 19.3893 4.3369L19.7838 4.24665L19.9891 4.22217ZM53.1673 11.3017L40.2801 20.3611V48.7097L53.1673 39.6503V11.3017ZM17.7199 11.2909L4.83269 20.3504V48.6987L17.7199 39.6394V11.2909ZM22.5602 11.2909V39.6394L35.4474 48.6987V20.3504L22.5602 11.2909Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts3);
export default __webpack_public_path__ + "static/media/contacts-3.9cf4a917da8a4adf63f404a9e47bfd35.svg";
export { ForwardRef as ReactComponent };